import { FC } from 'react';
import styled from 'styled-components';

interface Props {
	text: string;
	onClick: () => void;
}

const BackButton: FC<Props> = ({ text, onClick }) => (
	<Button onClick={onClick}>
		<ArrowWrapper>
			<img alt="Back Arrow" src="/images/icons/back-arrow-btn.svg" />
		</ArrowWrapper>

		<span>{text}</span>
	</Button>
);

const Button = styled.button`
	display: flex;
	margin: 0 auto;
	cursor: pointer;
	align-items: center;
	min-width: 140px;
	background-color: var(--color-white-30);
	border-radius: 12px;
	padding: 10px 20px 10px 14px;
	font-family: var(--font-sans);
	color: var(--color-purple-50);

	font-weight: var(--font-medium);
	font-size: 14px;
	line-height: 20px;
`;

const ArrowWrapper = styled.span`
	display: block;
	position: relative;
	width: 26px;
	height: 26px;
	border-radius: 50%;
	margin-right: 7px;

	img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;

export default BackButton;
